// extracted by mini-css-extract-plugin
export var container = "_rf-0";
export var dotAnimation = "_rf-2";
export var dotsLoading = "_rf-1";